import moment from 'moment';
import _ from 'lodash';

import {
  OnHandReportTransactionDetailsEnum,
  TransactionDetailsEnum,
  SiteEnum,
} from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

import * as types from './types';

const INITIAL_STATE = {
  //on hand
  onHandItems: [],
  loadingOnHandItems: false,
  loadingOnHandItemsError: null,

  //get all sites
  allSitesData: [],
  loadingAllSites: false,
  allSitesLoadingError: null,

  //fifo
  onHandFifoItems: [],
  loadingOnHandFifoItems: false,
  loadingOnHandFifoItemsError: null,
  selectedFifoSitesItems: [],

  //transaction details
  onHandTransactionDetailsItems: [],
  loadingOnHandTransactionDetailsItems: false,
  loadingOnHandTransactionDetailsItemsError: null,

  fromDateMax: moment().add(1, 'month'),
  toDateMin: moment().subtract(1, 'month'),
  fromDateMaxTranDetail: moment().add(1, 'month'),
  toDateMinTranDetail: moment().subtract(1, 'month'),
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ON_HAND_REPORT_ITEMS_LOADING:
      return {
        ...state,
        loadingOnHandItems: action.payload,
      };

    case types.ON_HAND_REPORT_ITEMS:
      return {
        ...state,
        onHandItems: action.payload,
      };

    case types.ON_HAND_REPORT_ITEMS_LOADING_ERROR:
      return {
        ...state,
        loadingOnHandItemsError: action.payload,
      };

    //sites
    case types.ON_HAND_REPORT_SITES_LOADING:
      return {
        ...state,
        loadingAllSites: action.payload,
      };

    case types.ON_HAND_REPORT_SITES_DATA:
      const sites =
        action.payload && action.payload.length
          ? _.map(action.payload, site => {
              site[SiteEnum.IsSelected] = true;
              return site;
            })
          : [];
      return {
        ...state,
        allSitesData: sites,
      };

    case types.ON_HAND_REPORT_SITES_LOADING_ERROR:
      return {
        ...state,
        allSitesLoadingError: action.payload,
      };

    case types.RESET_ON_HAND_REPORT_ITEMS_LOADING_ERROR:
      return {
        ...state,
        loadingOnHandItemsError: null,
      };

    //fifo
    case types.FIFO_REPORT_LOADING:
      return {
        ...state,
        loadingOnHandFifoItems: action.payload,
      };

    case types.FIFO_REPORT_ITEMS:
      const onHandFifoItemsCopy = _.cloneDeep(action.payload);
      onHandFifoItemsCopy.forEach(item => {
        item.ReceiptDT = moment(item.ReceiptDT).format(DATE_FORMAT_FOR_UI);
        item.Price = Number(item.Price).toFixed(4);
      });
      return {
        ...state,
        onHandFifoItems: onHandFifoItemsCopy,
      };

    case types.FIFO_REPORT_LOADING_ERROR:
      return {
        ...state,
        loadingOnHandFifoItemsError: action.payload,
      };

    case types.SET_SELECTED_SITES_ITEMS_FOR_FIFO:
      return {
        ...state,
        selectedFifoSitesItems: action.payload,
      };

    case types.TRANSACTION_DETAILS_REPORT_LOADING:
      return {
        ...state,
        loadingOnHandTransactionDetailsItems: action.payload,
      };

    case types.TRANSACTION_DETAILS_REPORT_ITEMS:
      const transactionData = _.cloneDeep(action.payload);
      transactionData.forEach(item => {
        item.SiteIdName = item[OnHandReportTransactionDetailsEnum.Site];
        item.TransactionName =
          item[OnHandReportTransactionDetailsEnum.TransactionId] +
          ': ' +
          item[OnHandReportTransactionDetailsEnum.Transaction];
        item[OnHandReportTransactionDetailsEnum.TransactionDT] = moment(
          item[OnHandReportTransactionDetailsEnum.TransactionDT]
        ).format(DATE_FORMAT_FOR_UI);
        item[TransactionDetailsEnum.PrimaryPrice] = Number(
          item[TransactionDetailsEnum.PrimaryPrice]
        ).toFixed(4);
        item[TransactionDetailsEnum.SecondaryPrice] = Number(
          item[TransactionDetailsEnum.SecondaryPrice]
        ).toFixed(4);
      });
      return {
        ...state,
        onHandTransactionDetailsItems: transactionData,
      };

    case types.TRANSACTION_DETAILS_REPORT_LOADING_ERROR:
      return {
        ...state,
        loadingOnHandTransactionDetailsItemsError: action.payload,
      };

    case types.CLEAR_REPORT_ERROR:
      return {
        ...state,
        loadingOnHandItemsError: null,
        allSitesLoadingError: null,
        loadingOnHandFifoItemsError: null,
        loadingOnHandTransactionDetailsItemsError: null,
      };

    case types.SET_FROM_DATE_MAX:
      return {
        ...state,
        fromDateMax: action.payload,
      };

    case types.SET_TO_DATE_MIN:
      return {
        ...state,
        toDateMin: action.payload,
      };

    case types.SET_TRAN_DETAIL_FROM_DATE_MAX:
      return {
        ...state,
        fromDateMaxTranDetail: action.payload,
      };

    case types.SET_TRAN_DETAIL_TO_DATE_MIN:
      return {
        ...state,
        toDateMinTranDetail: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/state/reducer.js